<template>
  <div class="agreement">
    <div class="T_title" style="text-align: center">
      {{ appName }} User Agreement
    </div>
    <div class="T_content">
      Welcome to use {{ appName }} (hereinafter referred to as the "Platform" or
      "APP"). This platform is provided and operated by
      {{ appName }} (hereinafter collectively referred to as " {{ appName }}" or
      "we").
    </div>
    <div class="T_content">
      The "Terms of Service" (hereinafter referred to as "these Terms") you are
      currently reading is a legally binding agreement between you and us, which
      will govern your legal relationship with us and specify the conditions for
      your access to and use of this platform, our affiliated websites,
      services, applications, products, and content (collectively referred to as
      "Services"). Some Services or features (such as submitting or sharing user
      content) may have age restrictions, and not all users may be eligible to
      use them. This Service is only permitted for private, non-commercial
      purposes. In these Terms, "you" and "your" both refer to users of the
      Service.
    </div>
    <div class="T_content">
      Please be sure to read these terms carefully. If you are under 17 years
      old, you may only use this service with the consent of your parents or
      legal guardians. Please ensure that your guardians have reviewed and
      understood the content of these terms with you.
    </div>
    <br /><br />
    <div class="T_title">1. Changes to the Terms</div>

    <div class="T_content">
      We may revise these Terms from time to time based on service feature
      updates, multi-application/service integration, regulatory policy
      adjustments, and other circumstances. For significant changes to the
      Terms, we will use commercially reasonable efforts to notify all users
      through platform announcements and other means, but we still recommend
      that you regularly review these Terms to stay informed of the latest
      content.
      <br /><br />
      If you continue to access or use the Service after the revision of these
      Terms becomes effective, it shall be deemed that you have accepted the
      revised Terms; if you do not agree with the revised content, you must
      immediately stop accessing and using this Service.
    </div>
    <br /><br />
    <div class="T_title">2. Your Account</div>
    <br /><br />
    <div class="subtitle">2.1 Account Creation and Authorization</div>
    <br /><br />

    <div class="T_content">
      Using certain services may require you to create an account or for us to
      assign an account to you (hereinafter collectively referred to as
      "Account"). We reserve the right to adjust the account registration
      method.
    </div>
    <br /><br />
    <div class="subtitle">2.2 Account Linking Service</div>
    <br /><br />
    You agree that upon registering this account, you authorize us to activate
    the account for use of other services of the Company (specific available
    products shall be subject to our actual provision).
    <br /><br />
    <div class="subtitle">2.3 Account Ownership and Usage Restrictions</div>
    <br /><br />
    The account ownership belongs to us, and you only have the right to use the
    account. You shall not gift, borrow, rent, transfer, or sell the account to
    any third party.
    <br /><br />
    <div class="subtitle">2.4 Account Security and Liability</div>
    <br /><br />
    You are obliged to maintain the security of your account (including
    password, login information, etc.). If your account is hacked or your
    password is leaked due to improper operation on your part, you shall bear
    the relevant responsibilities. We will consider all operations performed
    through your account to have been initiated by you, and you shall be
    responsible for all actions under your account.
    <br /><br />
    If you discover any actual or suspected unauthorized use of your account,
    password theft, or other such situations, you should immediately notify us;
    under no circumstances shall you use another user's account or password.
    <br /><br />
    <div class="subtitle">2.5 Account Suspension and Termination</div>
    <br /><br />
    If you violate the provisions of these Terms or misuse the Services, we
    reserve the right to suspend or terminate the provision of Services to you.
    <br /><br />
    <div class="subtitle">2.6 Handling of Long-Term Unused Accounts</div>

    <br /><br />
    If your account has been inactive for a consecutive period of 1 year, we
    reserve the right to delete or reclaim the account (to avoid resource waste)
    without prior notice, and you shall bear all risks and losses arising
    therefrom. Meanwhile, we reserve the right to delete or reclaim your account
    and username at any time, at our sole discretion.
    <br /><br />
    <div class="T_title">3. Privacy Protection</div>

    <div class="T_content">
      Your privacy is of utmost importance to us. For the rules regarding our
      collection, use, and disclosure of your personal information, as well as
      how you can manage your personal privacy, please refer to the
      {{ appName }}
      Privacy Policy.
    </div>
    <br /><br />
    <div class="T_title">4. Use of Services</div>

    <div class="T_content">
      <div class="subtitle">4.1 Definition of User Content</div>

      <br /><br />
      <div class="subtitle">4.2 Prohibited Content and Conduct</div>
      You shall not use this service to create, upload, copy, send the following
      content, or engage in the following activities:
      <br /><br />
      1. Endangering national security, disclosing state secrets, subverting
      state power, or undermining national unity;
      <br /><br />
      2. that harms national honor and interests;
      <br /><br />
      3. Inciting ethnic hatred, ethnic discrimination, or undermining ethnic
      unity;
      <br /><br />
      4. Violating national religious policies, promoting cults, feudal
      superstitions;
      <br /><br />
      5. Spreading rumors, disrupting public order, and undermining social
      stability;
      <br /><br />
      6. Spreading or pornographic content, or containing sexually suggestive
      information;
      <br /><br />
      7. Disseminating content related to gambling, violence, homicide, or
      terrorism;
      <br /><br />
      8. Insulting, slandering others, infringing upon others' legitimate rights
      and interests, or engaging in fraudulent activities;
      <br /><br />
      9. Contains content that is insulting, intimidating, or threatening;
      <br /><br />
      10. Contains harassing information, junk email, malicious information, or
      phishing content;
      <br /><br />
      11. Leaking or involving others' privacy, personal information, and
      detailed data;
      <br /><br />
      12. Infringing upon the legitimate rights of others, such as the right of
      reputation, the right of portrait, intellectual property rights, trade
      secrets, etc.;
      <br /><br />
      13. Damaging the interests of Juveniles in any way;
      <br /><br />
      14. Tracking or harassing other users;
      <br /><br />
      15. contains misinformation, or steals others' avatars, profiles,
      impersonates others' identities to publish content or use services;
      <br /><br />
      16. Forcing or inducing other users to follow, click on a link page, or
      share information;
      <br /><br />
      17. fabricating facts, concealing the truth to mislead or deceive others;
      <br /><br />
      18. Contains advertising or sales-oriented content;
      <br /><br />
      19. Creating multiple fake accounts using technical means;
      <br /><br />
      20. Deletes the copyright information on this service and its copies;
      <br /><br />
      21. Conduct reverse engineering, reverse compilation, decompilation of the
      service, or attempt to obtain the source code of the service;
      <br /><br />
      22. Using, renting, lending, copying, modifying, linking, compiling,
      publishing, or creating a mirror website containing the company's
      intellectual property without authorization;
      <br /><br />
      23. Copying, modifying, adding, deleting, hooking up the necessary data
      published by this service, or creating derivative products of the service;
      <br /><br />
      24. By modifying, forging service instructions or data, adding, deleting,
      or altering service functions, or operating or disseminating the modified
      service (regardless of whether for commercial purposes);
      <br /><br />
      25. Logging in or using the service through third-party software, plugins,
      or systems not developed or authorized by us, or creating, publishing, or
      distributing such unauthorized tools;
      <br /><br />
      26. publishes or disseminates content that is offensive, indecent, or
      objectionable;
      <br /><br />
      27. Other content or behavior that violates laws and regulations
      (including the laws of your place of residence and the place where this
      service operates), infringes on the legitimate rights and interests of
      third parties, or disrupts the normal operation of this service.
      <br /><br />
      We will review the content you upload and provide feedback on the review
      results within 24 hours after the upload. If you violate the above
      agreement, we reserve the right to delete the relevant content; in serious
      cases, your account will be blocked.
      <br /><br />
    </div>
    <div class="subtitle">4.3 Responsibility Attribution for User Content</div>
    <br /><br />
    The user content you create, upload, copy, publish, or disseminate has no
    association with us and does not represent our views, positions, or
    policies. We assume no responsibility for your user content or your actions
    in using the service.
    <br /><br />
    <div class="subtitle">4.4 Your Warranties and Indemnities</div>
    <br /><br />
    You warrant that the information you transmit, produce, upload, copy,
    publish, or disseminate is true, legal, accurate, and effective, and you
    shall assume full responsibility for the relevant actions and consequences.
    If your actions cause damage to us or a third party, you shall compensate
    for the corresponding losses, and we reserve the right to hold you
    accountable in accordance with this clause.
    <br /><br />
    <div class="T_title">5. Intellectual Property</div>
    <br /><br />

    <div class="T_content">
      <div class="subtitle">
        5.1 Intellectual Property Rights of Platform Materials
      </div>
      <br /><br />
      All materials in the service (including but not limited to the selection
      and arrangement of designs, texts, graphics, pictures, videos,
      information, applications, software, music, sounds, and files), except for
      user-generated content (UGC) (collectively referred to as "platform
      materials"), are owned by us and/or third-party licensors in terms of
      ownership and intellectual property rights.
      <br /><br />
      You shall not acquire ownership of the platform materials by downloading
      platform materials or purchasing virtual currency/items; without our prior
      written permission, you shall not modify, copy, distribute, build,
      retransmit, download, scrape, display, publish, transmit, sell, or
      otherwise utilize the platform materials (in whole or in part). All rights
      not expressly granted to you in this clause are reserved by us and the
      licensors, and no license is granted by way of estoppel, implication, or
      otherwise.
    </div>
    <br /><br />
    <div class="subtitle">
      5.2 Intellectual Property Rights of User-Generated Content (UGC)
    </div>
    <br /><br />
    You represent and warrant that your User Content is original, you have full
    intellectual property rights thereto, and you have the right to grant all
    the rights and licenses provided for in this Agreement, and we shall not be
    liable for any third-party obligations or liabilities arising from the
    exercise of such rights.
    <br /><br />
    You assume full responsibility for your own user content, and we are not
    responsible for the user content uploaded or published by you or other
    users. By uploading, distributing, transmitting, or using user content in
    the service, you grant us a perpetual, non-exclusive, transferable,
    royalty-free, sublicensable global license to use, host, copy, modify,
    adapt, publish, translate, create derivative works, distribute, perform, and
    display your user content when operating, providing, and promoting the
    service.
    <br /><br />
    We do not guarantee the accuracy, quality, or completeness of user content;
    when you use the service, you may come into contact with offensive user
    content, for which we assume no responsibility. We reserve the right, at our
    sole discretion, to remove or permanently delete user content from the
    service without notice. If you discover user content or improper behavior
    that violates these terms, you may report it to us through customer service.
    <br /><br />
    <div class="T_title">6. Fees, Revenues, and Payments</div>
    <div class="subtitle">6.1 Service Fees</div>
    <br /><br />
    The basic functions of the service are available to you free of charge, but
    using certain features or obtaining virtual currency or virtual items may
    incur fees, and the specific prices will be displayed within the service.
    <br /><br />
    <div class="subtitle">6.2 Virtual Currency</div>
    <br /><br />
    Virtual currencies such as "Diamonds" that you purchase or acquire are only
    virtual items for in-service use (e.g., for uploading stories, using
    filters, video chatting, etc.), and you do not have ownership of the virtual
    currency.
    <br /><br />
    We shall not be liable for any actions related to the exercise of rights
    associated with virtual currency, and reserve the right to verify your
    identity and eligibility to use virtual currency. If we modify, suspend, or
    terminate virtual currency services, or if you incur losses due to service
    errors or other reasons, we shall not be required to repair or replace
    virtual currency, nor provide credit compensation or refunds.
    <br /><br />
    Virtual currency is non-relicensable, non-refundable, and non-transferable,
    even if it expires, is revoked, or is suspended; we may adjust the purchase
    price, usage method of virtual currency at any time, or revoke or stop
    publishing virtual currency without notice, refund, or compensation, and may
    also set an expiration date for virtual currency. Virtual currency cannot be
    exchanged for any legal tender or assets with monetary value.
    <br /><br />
    If you delete your account or your account is terminated, all unused virtual
    currency will be cleared, and no refund or compensation will be provided.
    <br /><br />
    <div class="subtitle">6.3 Payment Method</div>
    <br /><br />
    You can purchase paid services through third-party accounts (such as Apple
    iTunes accounts, Google Play accounts), and the relevant bills will be
    settled through the third-party accounts. The terms of service for
    third-party accounts are set by the third parties, which we have no control
    over, and we recommend that you review them on your own.
    <br /><br />
    <div class="subtitle">6.4 Revenue Rules</div>
    <div class="subtitle">A. Revenue Acquisition and Withdrawal</div>

    <br /><br />
    You may earn rewards from us, other users, and / or third-party sponsors and
    partners by using specific service features or participating in activities.
    Initially, these rewards may be stored within the service in the form of
    virtual credits (the name may vary).
    <br /><br />
    To apply for withdrawal of unsettled virtual credits, the following
    conditions must be met:
    <br /><br />
    i. You have reached the age of 18 or the legal age of adulthood in your
    country of nationality or country of residence (whichever is higher);
    <br /><br />
    ii. The source of income is legal and does not involve criminal, illegal, or
    regulatory violations;
    <br /><br />
    iii. You have not violated these Terms, other agreements with us or our
    affiliates, and/or platform
    <br /><br />
    If you do not meet the above conditions, you will not be able to withdraw
    funds; you may contact customer service to learn how to rectify the
    situation to meet the conditions, but we will not be liable for any related
    losses.
    <br /><br />
    <div class="subtitle">B. Suspension and Termination of Accounts</div>
    <br /><br />
    We reserve the right to refuse your access to the service or terminate or
    suspend your account without notice for any reason, including but not
    limited to your violation of these Terms; if you default, we may issue a
    warning to you or directly terminate your account.
    <br /><br />
    <div class="subtitle">
      C. Exemption from Liability for Service Interruptions
    </div>
    <br /><br />
    We may conduct planned or unplanned repairs and maintenance on the service.
    If such operations result in service interruption within a reasonable
    period, we shall not be liable to you and/or third parties, but will notify
    you as soon as possible.
    <br /><br />
    <div class="T_title">7. Risk Warning</div>
    <br /><br />
    <div class="subtitle">7.1 Your Responsibilities and Risk Assumptions</div>
    <br /><br />
    This service is only a platform for information sharing and transmission.
    You are required to take responsibility for all actions under your account
    (including content transmission and its consequences). You should
    independently judge the authenticity and effectiveness of the service
    content and bear all risks arising from the use of the service (such as
    losses caused by relying on the content). We shall not be responsible for
    the consequences of your actions.
    <br /><br />
    <div class="subtitle">7.2 Reporting of Violations</div>
    <br /><br />
    If you find that others violate these Terms or misuse the Service, please
    notify us immediately, and we will handle it in accordance with these Terms.
    <br /><br />
    <div class="subtitle">7.3 Service Changes and Termination</div>
    <br /><br />
    We reserve the right to change, suspend, or terminate all or part of the
    services at our sole discretion without notice.
    <br /><br />
    <div class="T_title">8. Liability Agreement</div>
    <br /><br />
    <div class="subtitle">8.1 Default Handling Measures</div>
    <br /><br />
    If you engage in illegal, regulatory - violating, contract - breaching, or
    tortious acts, we reserve the right to independently decide to take one or
    more of the following measures:
    <br /><br />
    - issues a warning to you;
    <br /><br />
    - Disable some of your service functions;
    <br /><br />
    - Terminate your access to the service;
    <br /><br />
    - Add you to the blocklist;
    <br /><br />
    - Disclose your default behavior;
    <br /><br />
    - Deduct and withhold your virtual items and virtual earnings.
    <br /><br />

    If we take measures to terminate your account or place you on the blocklist,
    your virtual items and earnings will not be refunded.
    <br /><br />
    <div class="subtitle">8.2 Assumption of Legal Liability</div>
    <br /><br />
    You understand and agree that if your actions are illegal, violate
    regulations, breach contracts, or infringe upon rights, we have the right to
    take remedial measures, initiate legal actions, and disclose your relevant
    information to relevant authorities in accordance with laws and regulations,
    and all consequences arising therefrom shall be borne by you.
    <br /><br />
    <div class="subtitle">8.3 Loss Compensation</div>
    <br /><br />
    If you violate these terms and cause losses (including but not limited to
    reasonable attorney's fees) to us or a third party, you shall be liable for
    full compensation.
    <br /><br />
    <div class="subtitle">8.4 indemnification</div>
    <br /><br />
    You agree to indemnify, defend, and hold us and our affiliates harmless from
    all complaints, claims, damages, losses, expenses, liabilities (including
    attorneys' fees) arising from the following circumstances:
    <br /><br />
    - You access or use the Service;
    <br /><br />
    - You violate these terms;
    <br /><br />
    - Your user content infringes upon third-party rights.
    <br /><br />
    <div class="subtitle">8.5 Superimposed Application of Measures</div>
    <br /><br />
    We reserve the right to choose to apply the above default handling measures
    individually or in combination.
    <br /><br />
    <div class="T_title">9. Disclaimer</div>
    <br /><br />
    To the extent permitted by applicable law, we shall not be liable for the
    following situations:
    <br /><br />
    <div class="subtitle">9.1 Force Majeure and Accidental Events</div>
    <br /><br />
    We shall not be liable for service interruptions or losses you may incur due
    to circumstances beyond our control and anticipation, such as natural
    disasters (e.g., floods, earthquakes, storms), social events (e.g., wars,
    unrest, government actions), etc., but we will do our best to cooperate in
    the repair.
    <br /><br />
    <div class="subtitle">9.2 Exemption from Liability for Service Quality</div>
    <br /><br />
    We do not guarantee that the service will always be secure, reliable,
    available, uninterrupted, error-free, or without delay, nor do we make any
    express or implied warranties (including but not limited to warranties of
    title, non-infringement, merchantability, and fitness for a particular
    purpose) regarding the service.
    <br /><br />
    We cannot control your behavior or that of other users, nor are we
    responsible for the content of other users (including offensive, indecent,
    illegal, or controversial content).
    <br /><br />
    <div class="subtitle">9.3 Exemption from Liability for Safety Risks</div>
    <br /><br />
    Services may be affected by factors such as Internet quality, social
    environment, third-party software (which may contain viruses or Trojans),
    etc., resulting in damage to your device information and data security or
    the inability to use the service normally. Please strengthen password
    protection, and we will not be responsible for losses caused by such
    security risks.
    <br /><br />
    <div class="subtitle">
      9.4 Exemption from Liability for Technical Failures
    </div>
    <br /><br />
    We shall not be liable for any service interruption or losses you may incur
    due to unavoidable technical issues (such as computer viruses, hacker
    attacks, system instability), your location, device shutdown, Internet or
    telecommunications failures, etc.
    <br /><br />
    <div class="subtitle">9.5 Disclaimer for Third-Party Content</div>
    <br /><br />
    There may be misleading, deceptive, threatening, defamatory, illegal, or
    infringing third-party content in the service, and we shall not be liable
    for any losses incurred by you or third parties due to such content.
    <br /><br />
    <div class="subtitle">
      9.6 Exemption from Liability for Service Maintenance
    </div>
    <br /><br />
    We may perform maintenance, updates, and repairs on the service periodically
    or non-periodically. If such operations result in service interruption
    within a reasonable period and after prior notice, we shall not be liable.
    <br /><br />
    <div class="subtitle">
      9.7 Exemption from Liability for Third-Party Actions
    </div>
    <br /><br />
    We reserve the right, but not the obligation, to handle third-party breaches
    of contract, infringements, and illegal acts, and do not guarantee the
    timely discovery and handling of such acts.
    <br /><br />
    <div class="subtitle">9.8 Disclaimer for Free Products/Services</div>
    <br /><br />
    We shall not be liable for any quality defects or losses caused by the
    products or services provided to you free of charge.
    <br /><br />
    <div class="subtitle">9.9 Exemption from Liability for Indirect Losses</div>
    <br /><br />
    We shall not be liable for any indirect, incidental, special, punitive, or
    consequential damages (including but not limited to loss of profits, loss of
    goodwill, and loss of data), whether such damages are caused by the use or
    inability to use the services, or by the actions of third parties (including
    other users and operators of external websites).
    <br /><br />
    Notwithstanding any other provisions in this clause, our total liability for
    compensation (regardless of the reason) shall not exceed the total amount of
    fees you have paid to us (or zero if no fees have been paid).
    <br /><br />
    <div class="subtitle">9.10 Risks of Offline Interaction</div>
    <br /><br />
    If you meet other users offline or conduct transactions, you may face risks
    to personal and property safety or transaction disputes. Such risks and
    losses shall be borne by you, and we shall not assume any liability.
    <br /><br />
    <div class="T_title">10. Other Agreements</div>
    <br /><br />

    <div class="subtitle">10.1 Key Points of Clause</div>
    <br /><br />
    Please pay special attention to the content in this clause regarding
    disclaimers, risk warnings, rights limitations, and our responsibilities; if
    you are a Juvenile, please read it under the supervision of a guardian.
    <br /><br />
    <div class="subtitle">10.2 Effectiveness of Supplementary Rules</div>
    <br /><br />
    Other statements and rules published by us in the service are all
    supplements to these Terms, have the same legal effect as these Terms, and
    together constitute a complete agreement.
    <br /><br />
    <div class="subtitle">10.2 Effectiveness of Supplementary Rules</div>
    <br /><br />
    Other statements and rules published by us in the service are all
    supplements to these Terms, have the same legal effect as these Terms, and
    together constitute a complete agreement.
    <br /><br />
    <div class="subtitle">10.3 Governing Law and Dispute Resolution</div>
    <br /><br />
    This Clause shall be governed by and construed in accordance with the laws
    of the Hong Kong Special Administrative Region. Any dispute arising out of
    or in connection with this Clause (including its existence, validity, and
    termination) shall be submitted to the Hong Kong International Arbitration
    Centre for final arbitration in accordance with its then-effective
    arbitration rules.
    <br /><br />
    <div class="subtitle">10.4 Severability of Clause</div>
    <br /><br />
    If any provision of this Agreement is held by a competent authority to be
    invalid or unenforceable, it shall not affect the validity of the remaining
    provisions; the parties shall endeavor to negotiate alternative provisions
    to achieve the commercial purpose of the original provision.
    <br /><br />
    <div class="subtitle">10.5 Contact Us</div>
    <br /><br />
    If you have any questions, comments, or suggestions regarding these terms,
    please contact us via email at {{ appEmail }}, and we will review and
    respond promptly. <br /><br />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
};
</script>

<style scoped>
.agreement {
  padding: 0px 25px;
  color: #666;
}
.T_title {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0.5333rem 0px;
  color: #000;
}
.subtitle {
  font-size: 1.1rem;
  color: #333;
}
.T_content {
  font-size: 1rem;
  margin-bottom: 0.4667rem;
  color: #666;
}
.title_content {
  font-size: 1rem;
  margin-bottom: 0.4667rem;
  color: #666;
  margin-left: 0.4rem;
  margin-right: 0.4rem;
}
</style>
